var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-pay-layout',[_c('v-layout',{attrs:{"column":_vm.$vuetify.breakpoint.smAndDown}},[_c('v-flex',[_c('v-card',{staticClass:"mb-3 mx-2",attrs:{"max-width":"700px"}},[_c('m-pay-merchant-employee-editor',{attrs:{"loading":_vm.loading},on:{"cancel":_vm.cancel,"submit":_vm.addMerchantEmployee}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a91f721","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/merchant/MPayMerchantEmployeeCreateView.vue
// module id = null
// module chunks = 